<template>
  <div>
    
    <h1>Associar Tarefas</h1>

    <div class="container-dados-usuario" 
      v-if="!loadingTarefasMobilidades && listaDadosAssociados.length || listaDadosDisponiveis.length">
      <h5>Tarefa: <small>{{ tarefaMobilidade.tarefa }}</small> </h5>
    </div>

    <div class="mcontainer-fluid">
      <div class="mdn-Row">
        <div class="mdn-Col-xs mdn-u-marginTop--xs">
          <SGPAssociarComponent
            v-if="(listaDadosAssociados.length || listaDadosDisponiveis.length) && !loadingTarefasMobilidades"
            tituloAssociados="Tarefas"
            tituloDisponiveis="Tarefas"
            :dadoAssociado="listaDadosAssociados"
            :dadoDisponivel="listaDadosDisponiveis"
            @sgpSalvarAssociacoesEmit="tarefasParaAssociar"
            @change="atualizarListas($event)"
          />
        </div>
      </div> 
    </div>
    <SGPLoadingComponent v-if="loadingTarefasMobilidades" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { CTRL_TIPO_TAREFA } from '../../../../common/boot/Constantes'

export default {
  name: 'TarefaMobilidadeAssociacaoPage',

  data () {
    return {
      listaDadosAssociados: [],
      listaDadosDisponiveis: []
    }
  },

  async created () {
    await this.listarTarefasComFiltro({
      ativo: 1
    });
    await this.recuperarTarefaMobilidade(this.$route.params.tarefa);

    this.atualizarListaDeDadosAssociadosENaoAssociados();
    this.recuperarMobilidadeTarefaOrigem({
      ctrl_tarefa_id: this.$route.params.tarefa
    });
  },

  computed: {
    ...mapGetters('ctrlTarefasMobilidades', [
      'tarefaMobilidadeSelecionada',
      'loadingTarefasMobilidades',
      'listaDeMobilidadesTarefaOrigem'
    ]),
    
    ...mapGetters('ctrlTarefas', ['listaDeTarefasAtivas']),
    ...mapGetters('tiposTarefas', ['listaDeTiposTarefas']),
    ...mapGetters('ctrlConclusoes', ['listaDeConclusoes']),
   
    tarefaMobilidade () {
      return this.tarefaMobilidadeSelecionada;
    },

    tarefasAssociadas () {      
      return this.listaDeMobilidadesTarefaOrigem.map(item => {
        return {
          id: item.ctrl_tarefa_destino_id,
          descricao: item.ctrl_tarefa_destino.tarefa+' - '+item.ctrl_tipo_tarefa.tipo,
          selecionado: false
        }
      });
    },

    tarefasDisponiveis () {
      return this.filtrarTarefasDisponiveis()
      .map(item => {
        return {
          id: item.id,
          descricao: item.tarefa+' - '+item.ctrl_tipo_tarefa.tipo,
          selecionado: false
        }
      })
    }
  },

  methods: {
    ...mapActions('ctrlTarefas', [ 'listarTarefasComFiltro']),
    ...mapActions('ctrlTarefasMobilidades', [
      'recuperarTarefaMobilidade',
      'associarTarefaMobilidade',
      'associarFormularioMobilidade',
      'recuperarMobilidadeTarefaOrigem'
    ]),

    filtrarTarefasDisponiveis () {
      const listaDeItemsAssociados = this.listaDeMobilidadesTarefaOrigem
      .map(item => item.ctrl_tarefa_destino_id);

      let listaFiltrada = null;
      if (this.tarefaMobilidadeSelecionada.ctrl_tipo_tarefa_id == CTRL_TIPO_TAREFA.INTERRUPCAO) {
        listaFiltrada = this.listaDeTarefasAtivas.filter(item => {
          return (!listaDeItemsAssociados.includes(item.id) && item.id != this.$route.params.tarefa)
                && item.deleted_at === null 
                && item.ctrl_tipo_tarefa_id == CTRL_TIPO_TAREFA.INTERRUPCAO
        });
      }else {
        listaFiltrada = this.listaDeTarefasAtivas.filter(item => {
          return (!listaDeItemsAssociados.includes(item.id) && item.id != this.$route.params.tarefa) 
                 && item.deleted_at === null
        });
      }

      return listaFiltrada;
    },

    atualizarListas(event) {
      if(typeof event == 'undefined'){
        return false;
      }
      this.atualizarListaDeDadosAssociadosENaoAssociados();
    },
    
    atualizarListaDeDadosAssociadosENaoAssociados () {
      this.listaDadosAssociados = this.tarefasAssociadas
      this.listaDadosDisponiveis = this.tarefasDisponiveis
    },

    async tarefasParaAssociar (value) {
      const listaIdsAssociados = value.listaAssociados.map(item => {
        return item.id
      });

      const listaIdsDesassociados = value.listaDisponivel.map(item => {
        return {id: item.id, ctrl_conclusao_id: this.ctrl_conclusao_id}
      });

      const idsParaAssociacao = [];

      listaIdsAssociados.forEach(id => {
        idsParaAssociacao.push({
          id,
        });
      })

      const payload = {
        ctrl_tarefa_origem_id: this.$route.params.tarefa,
        tarefasParaAssociar: idsParaAssociacao,
        tarefasParaDesassociar: listaIdsDesassociados
      }
    
      await this.associarTarefaMobilidade(payload);
    }
  },

  watch: {
    tarefasDisponiveis(){
      this.atualizarListaDeDadosAssociadosENaoAssociados(); 
    }
  },
}
</script>
